import PropTypes from 'prop-types';

const displayName = 'StaticAccordion';
const propTypes = {
  data: PropTypes.object.isRequired,
  itemClick: PropTypes.func.isRequired,
  intl: PropTypes.object,
};
const defaultProps = {};

export default {
  displayName,
  propTypes,
  defaultProps,
};
